"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseApiService = void 0;
const typescriptHacks_1 = require("../../helper/typescriptHacks");
class BaseApiService {
    constructor(newBaseUrl) {
        this._baseUrl = 'https://api.assistantapps.com';
        this.addAccessTokenToHeaders = () => typescriptHacks_1.anyObject;
        this.formDataWithAccessTokenHeaders = () => typescriptHacks_1.anyObject;
        this._baseUrl = newBaseUrl;
    }
    get(url, manipulateHeaders, manipulateResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            //
            let options = typescriptHacks_1.anyObject;
            if (manipulateHeaders != null) {
                options = Object.assign(Object.assign({}, options), manipulateHeaders());
            }
            let result = typescriptHacks_1.anyObject;
            try {
                result = yield fetch(`${this._baseUrl}/${url}`, options);
                if (manipulateResponse != null) {
                    return manipulateResponse(result);
                }
            }
            catch (ex) {
                console.log('data', ex.toString());
                return {
                    isSuccess: false,
                    value: typescriptHacks_1.anyObject,
                    errorMessage: ex.toString()
                };
            }
            let resultValue = typescriptHacks_1.anyObject;
            try {
                resultValue = yield result.json();
            }
            catch (ex) { }
            return {
                isSuccess: true,
                value: resultValue,
                errorMessage: ''
            };
        });
    }
    post(url, data, manipulateHeaders, customMapper) {
        return __awaiter(this, void 0, void 0, function* () {
            //
            let options = typescriptHacks_1.anyObject;
            if (manipulateHeaders != null) {
                options = Object.assign(Object.assign({}, options), manipulateHeaders());
            }
            let result = typescriptHacks_1.anyObject;
            try {
                result = yield fetch(`${this._baseUrl}/${url}`, Object.assign(Object.assign({}, options), { method: 'POST', headers: Object.assign({ 'Accept': 'application/json', 'Content-Type': 'application/json' }, options.headers), body: JSON.stringify(data) }));
                if (customMapper != null) {
                    return customMapper(result);
                }
            }
            catch (ex) {
                console.log('data', ex.toString());
                return {
                    isSuccess: false,
                    value: typescriptHacks_1.anyObject,
                    errorMessage: ex.toString()
                };
            }
            let resultValue = typescriptHacks_1.anyObject;
            try {
                resultValue = yield result.json();
            }
            catch (ex) { }
            return {
                isSuccess: true,
                value: resultValue,
                errorMessage: ''
            };
        });
    }
    put(url, data, manipulateHeaders, customMapper) {
        return __awaiter(this, void 0, void 0, function* () {
            //
            let options = typescriptHacks_1.anyObject;
            if (manipulateHeaders != null) {
                options = Object.assign(Object.assign({}, options), manipulateHeaders());
            }
            let result = typescriptHacks_1.anyObject;
            try {
                result = yield fetch(`${this._baseUrl}/${url}`, Object.assign(Object.assign({}, options), { method: 'PUT', headers: Object.assign({ 'Accept': 'application/json', 'Content-Type': 'application/json' }, options.headers), body: JSON.stringify(data) }));
                if (customMapper != null) {
                    return customMapper(result);
                }
            }
            catch (ex) {
                console.log('data', ex.toString());
                return {
                    isSuccess: false,
                    value: typescriptHacks_1.anyObject,
                    errorMessage: ex.toString()
                };
            }
            let resultValue = typescriptHacks_1.anyObject;
            try {
                resultValue = yield result.json();
            }
            catch (ex) { }
            return {
                isSuccess: true,
                value: resultValue,
                errorMessage: ''
            };
        });
    }
    delete(url, manipulateHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            //
            let options = typescriptHacks_1.anyObject;
            if (manipulateHeaders != null) {
                options = Object.assign(Object.assign({}, options), manipulateHeaders());
            }
            let result = typescriptHacks_1.anyObject;
            try {
                result = yield fetch(`${this._baseUrl}/${url}`, Object.assign(Object.assign({}, options), { method: 'DELETE' }));
            }
            catch (ex) {
                console.log('data', ex.toString());
                return {
                    isSuccess: false,
                    errorMessage: ex.toString()
                };
            }
            let resultValue = typescriptHacks_1.anyObject;
            try {
                resultValue = yield result.json();
            }
            catch (ex) { }
            return {
                isSuccess: true,
                errorMessage: ''
            };
        });
    }
}
exports.BaseApiService = BaseApiService;
